import CircularButton from "@/components/CircularButton";
import { memo, useCallback } from "react";

export type ColorButtonProps = {
    color?: string;
    active?: boolean;
    onColorChange?: (color: string) => void;
};

export const ColorButton = memo(({ color, active, onColorChange }: ColorButtonProps) => {
    const wrapperStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "6px",
        borderRadius: "4px",
        backgroundColor: "transparent",
        ...(!active && {
            "&:hover": {
                backgroundColor: "#F5F5F5",
            },
        }),
    };

    const bubbleStyle = {
        width: "16px",
        height: "16px",
        borderRadius: "4px",
        backgroundColor: color,
        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
        ringOffsetWidth: "2px",
        ringColor: "currentColor",
        ...(active
            ? {
                  ring: "1px solid currentColor",
              }
            : {
                  "&:hover": {
                      ring: "1px solid currentColor",
                  },
              }),
    };

    const handleClick = useCallback(() => {
        if (onColorChange) {
            onColorChange(color || "");
        }
    }, [onColorChange, color]);

    return (
        <CircularButton component="button" onClick={handleClick} sx={wrapperStyle}>
            <div
                data-color={color}
                style={{ color: color, ...bubbleStyle }}
                data-testid="auto-id-e8a6f44e-0539-4e3e-a752-5a719a447d9a"></div>
        </CircularButton>
    );
});

ColorButton.displayName = "ColorButton";
